import { ExistingSystemType, LevelType } from 'data/types';
import {
  COMPONENT_TYPE_TO_POSITION,
  isExistingEquipmentComponentPlaced
} from 'utils/existing-equipment';

export type DuctedLayoutLevelPartition = ReadonlySet<string> | undefined;

function placedIndoorLevelUniqueId(
  existingSystem: ExistingSystemType | null
): string | undefined {
  const indoor = existingSystem?.components.find((component) => {
    const slot = COMPONENT_TYPE_TO_POSITION[component.type];
    return (
      (slot === 'blower' || slot === 'indoor') &&
      isExistingEquipmentComponentPlaced(component)
    );
  });
  return indoor?.levelUniqueId;
}

export function partitionLayoutLevels(
  existingSystems: (ExistingSystemType | null)[],
  structure: LevelType[]
): DuctedLayoutLevelPartition[] {
  if (existingSystems.length <= 1) {
    return existingSystems.map(() => undefined);
  }
  const levelIds = structure.map((level) => level.uniqueId);
  const indoorLevels = existingSystems.map(placedIndoorLevelUniqueId);
  const claimed = new Set(
    indoorLevels.filter((id): id is string => !!id && levelIds.includes(id))
  );
  const unclaimed = levelIds.filter((id) => !claimed.has(id));
  const unplacedIndexes = indoorLevels
    .map((id, index) => (id && claimed.has(id) ? -1 : index))
    .filter((index) => index >= 0);
  const unclaimedOwner = unplacedIndexes.length > 0 ? unplacedIndexes[0] : 0;

  return indoorLevels.map((indoorLevel, index) => {
    const owned = new Set<string>();
    if (indoorLevel && claimed.has(indoorLevel)) owned.add(indoorLevel);
    if (index === unclaimedOwner) {
      unclaimed.forEach((id) => owned.add(id));
    }
    return owned;
  });
}
